// Значки разделов меню. Пункты внутри разделов и верхние пункты — текстом (решения 066, 067).
//
// ⚠ Значок — второй признак: разделы называют слова из `CFG-141`, значок лишь
// помогает найти раздел взглядом. Раздел без записи здесь получает нейтральный
// кружок, а не пустое место.

import {
  BarChart3,
  LayoutDashboard,
  BookOpen,
  Circle,
  CreditCard,
  Inbox,
  Send,
  Settings2,
  TrendingUp,
  type LucideIcon,
} from "lucide-react";

const GROUPS: Readonly<Record<string, LucideIcon>> = {
  // Значки разделов — как на принятой картинке Σ.
  operations: CreditCard,
  income: Inbox,
  money: Send,
  profit: BarChart3,
  strategy: TrendingUp,
  directories: BookOpen,
  system: Settings2,
};

/** Верхние пункты (решение 066) сохраняют значок на линии значков разделов; пункты внутри разделов — текстом. */
const TOP: Readonly<Record<string, LucideIcon>> = { "S-52": LayoutDashboard };

/** Значок верхнего пункта по коду поверхности; нет записи — нет значка. */
export function TopIcon({ code }: { readonly code: string }) {
  const Icon = TOP[code];
  return Icon === undefined ? null : <Icon aria-hidden="true" className="size-4 shrink-0" />;
}

/** Значок раздела по ключу группы. */
export function GroupIcon({ group, className = "size-4" }: { readonly group: string; readonly className?: string }) {
  const Icon = GROUPS[group] ?? Circle;
  return <Icon aria-hidden="true" className={`shrink-0 ${className}`} />;
}
